import React, { useState } from "react";
import { authenticationService } from "../../services/AuthinticationService";
import formData from "../../components/forms/formsData.json";
import { useNavigate, useParams } from "react-router-dom";
import utils from "../../utils/utils";
import { Error } from "../../components/forms/Error";
import { FormBuilder } from "../../components/forms/FormBuilder";
import { TextInput } from "../../components/input/TextInput";
import AlertConfirm from "../../components/modals/Confirm";
import ReCAPTCHA from "react-google-recaptcha";
import GenIcon from "../../assets/GenMedicIcon.png";
export function Register() {
  const [RegisterInputs, setRegisterInputs] = useState({
    Email: "",
  });
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isError, setIsError] = useState(false);
  const [formType, setFormType] = useState(formData["register"]);
  const [BackendErrors, setBackendErrors] = useState(null);

  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const SubmitFunc = async () => {
    if (true) {
      navigate("/verificationCode", {
        state: { type: "email", value: RegisterInputs.Email },
      });
      let response = await authenticationService.login(
        RegisterInputs.Email,
        RegisterInputs.Password,
        recaptchaValue,
      );
      sessionStorage.setItem("Email", RegisterInputs.Email);
      sessionStorage.setItem("Password", RegisterInputs.Password);

      if (response && response.status < 400) {
        let data = response.data;
        if (
          data &&
          data.hasOwnProperty("status") &&
          String(data["status"]).toLowerCase() === "2fa"
        ) {
          let emailAddress = RegisterInputs.Email;
          navigate("/verificationCode", {
            state: { type: "email", value: emailAddress },
          });
        } else if (
          data &&
          data.hasOwnProperty("status") &&
          String(data["status"]).toLowerCase() === "pass"
        ) {
          let token = data.profile.token;
          let role = data.profile.Role;
          if (data.profile["PassNeedsToChange"]) {
            navigate("/ResetPassword");
          } else {
            const route = role ? role : "";
            if (role === "Call Center") navigate(`/${route}/DeviceManagement`);
            else navigate(`/${route}/Dashboard`);
          }
        }
      } else {
        let responseError =
          response && response.response ? response.response.data.error : "";
        if (responseError === "locked") {
          let confirmApprove = await AlertConfirm(
            {
              proceedLabel: "OK",
              cancelLabel: "none",
              options: { hasSVG: true, svgName: "alert-triangle" },
            },
            "Please contact the the admin to unlock the user.",
            `Your account has been locked.`,
          );
        }
        setBackendErrors("Wrong Email or Password. Please try again");
      }
    } else {
      console.error("Please complete reCAPTCHA.");
    }
  };

  const handleChange = async (event) => {
    let inputs = { ...RegisterInputs };
    let name = event.target.name;
    let value = event.target.value;
    RegisterInputs[name] = event.target.value;
    let form = [...formType];
    let formErrors = { ...error };
    if (value === "") {
      value = null;
    }
    switch (name) {
      case "Email":
        if (value && !utils.mailValidation(value)) {
          formErrors["Email"] = true;
          setIsError(true);
          form[0]["error"] = "Please enter valid Email";
        } else if (!value) {
          form[0]["error"] = "Please enter Email";
          formErrors["Email"] = true;
          setIsError(true);
        } else {
          formErrors["Email"] = false;
          form[0]["error"] = "";
        }
        break;
      case "Password":
        if (!value) {
          form[1]["error"] = "Please enter password";
          formErrors["Password"] = true;
          setIsError(true);
        } else {
          formErrors["Password"] = false;
          form[1]["error"] = "";
        }
        break;
      default:
        setIsError(false);
    }
    inputs[name] = value;
    setRegisterInputs(inputs);
    setFormType(form);
    setError(formErrors);
    setBackendErrors(null);
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const recaptchaRef = React.createRef();

  return (
    <div className="p-[37px_20px_0px_20px] rounded-[32px] flex flex-col justify-self-center items-center self-center justify-start w-register h-register gap-[25px] bg-gray-800-opacity-30 bg-blend-luminosity border-gradient-custom">
      {/* <SVGraphics className={'flex min-w-[23rem] min-h-[3.75rem] '}
                        svgname={'verticaPlus'} fill={'none'}/> */}

      <div className="logo-container flex items-center justify-center w-fit h-fit">
        <img src={GenIcon} alt="Genesis" />
      </div>

      <div className="w-full z-10">
        <div className={" flex-col flex gap-1 items-center"}>
          <TextInput
            text={"Register"}
            className={"text-white text-[30px] font-medium"}
          />
          <TextInput
            text={"The User Co-Pilot"}
            className={"text-[16px] text-white text-opacity-50"}
          />
        </div>

        <div className={"flex flex-col items-center w-full p-0 "}>
          <FormBuilder
            data={formType}
            formData={RegisterInputs}
            onChange={(e) => handleChange(e)}
            containerClassName={"flex-col flex w-full h-full items-center z-10"}
            inputClassName="custom-input rounded-[10px] h-[56px] w-[429px] z-20 font-normal font-Inter"
            isShown={error}
            type={showPassword ? "text" : "password"}
            showPassword={showPassword}
            showOnClick={() => setShowPassword(!showPassword)}
            isError={isError}
          />

          <div className="mt-[1rem]">
            <button
              type="button"
              onClick={() => SubmitFunc()}
              disabled={
                !RegisterInputs["Email"] ||
                (RegisterInputs["Email"] &&
                  !utils.mailValidation(RegisterInputs["Email"]))
              }
              className="rounded-[10px] flex w-[429px] h-[56px] justify-center items-center flex-shrink-0 text-white
                            font-Poppins text-lg font-[500] text-[16px] button-glow"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <div
        className={
          "w-full font-normal text-white z-10 text-center text-base " +
          "text-base font-normal leading-normal "
        }
      >
        Already have an account?
        <span
          className="
        link-text
        "
          onClick={() => navigate("/login")}
        >
          Login
        </span>
      </div>
      <div className={"w-full text-left mt-2 text-lg"}>
        <Error message={BackendErrors} isShown={BackendErrors} />
      </div>
      <div className={"hidden"}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          onChange={handleRecaptchaChange}
          size="invisible"
        />
      </div>
    </div>
  );
}
